import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Append directly to head instead of inserting before existing script
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // Initialize pixel
    ;
    (window as any).fbq('init', '431177316638551');
    (window as any).fbq('track', 'PageView');
    // Track when user clicks on CTA buttons
    const trackButtonClick = () => {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    };
    // Add event listeners to all CTA links
    const ctaLinks = document.querySelectorAll('a[href*="checkout.ebookditales.com"]');
    ctaLinks.forEach(link => {
      link.addEventListener('click', trackButtonClick);
    });
    // Cleanup
    return () => {
      ctaLinks.forEach(link => {
        link.removeEventListener('click', trackButtonClick);
      });
    };
  }, []);
  return <noscript data-id="element-53">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=431177316638551&ev=PageView&noscript=1" alt="" data-id="element-54" />
    </noscript>;
}